import { AxiosPromise } from 'axios';

import { Violations } from '@/models/violations';

import { api, decomposeParams } from '.';

export const getViolations = (
  params?: Violations.ViolationParams
): AxiosPromise<Violations.List> =>
  api.get(`/v2/violations${decomposeParams(params)}`);

export const getViolationById = (
  postId: number,
  params?: Violations.ViolationParams
): AxiosPromise<Violations.Details> =>
  api.get(`/v2/violations/${postId}${decomposeParams(params)}`);

// Contact endpoints
export const addViolationContact = (
  postId: number,
  data: Pick<Violations.Contacted, 'contactedAt'>
): AxiosPromise<Violations.Contacted> =>
  api.post(`/v2/violations/${postId}/contact`, {
    timeOfContact: data.contactedAt
  });

export const updateViolationContact = (
  postId: number,
  contactId: number,
  data: Pick<Violations.Contacted, 'contactedAt'>
): AxiosPromise<Violations.Contacted> =>
  api.put(`/v2/violations/${postId}/contact/${contactId}`, {
    timeOfContact: data.contactedAt
  });

export const deleteViolationContact = (
  postId: number,
  contactId: number
): AxiosPromise<void> =>
  api.delete(`/v2/violations/${postId}/contact/${contactId}`);

// Status endpoint
export const updateViolationStatus = (
  postId: number,
  data: { status: Violations.StatusStage; comment?: string }
): AxiosPromise<Violations.Status> =>
  api.put(`/v2/violations/${postId}/status`, data);

// Opinion endpoint
export const updateViolationOpinion = (
  postId: number,
  data: Pick<Violations.SecondOpinion, 'opinion'>
): AxiosPromise<Violations.SecondOpinion> =>
  api.put(`/v2/violations/${postId}/opinion`, data);

// Comment endpoints
export const addViolationComment = (
  postId: number,
  data: { comment: string }
): AxiosPromise<Violations.Comment> =>
  api.post(`/v2/violations/${postId}/comment`, data);

export const updateViolationComment = (
  postId: number,
  commentId: number,
  data: { comment: string }
): AxiosPromise<Violations.Comment> =>
  api.put(`/v2/violations/${postId}/comment/${commentId}`, data);

export const deleteViolationComment = (
  postId: number,
  commentId: number
): AxiosPromise<void> =>
  api.delete(`/v2/violations/${postId}/comment/${commentId}`);

// Statistics endpoint
export const getViolationsStatistics = () =>
  api.get<Violations.Statistics>('/v2/violations/statistics');
